import type { FC } from "react";

interface SpinnerProps {
  size?: number;
}

export const Spinner: FC<SpinnerProps> = ({ size = 5 }) => {
  return (
    <svg
      className={`w-${size} h-${size} animate-spin`}
      viewBox="0 0 29 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.959 20.8633C25.8565 23.0858 24.1496 24.9523 22.0342 26.2485C19.9188 27.5447 17.4808 28.218 15 28.1911"
        stroke="url(#paint0_linear_10524_80194)"
        strokeWidth="2"
      />
      <path
        d="M14.999 28.1911C12.5183 28.218 10.0802 27.5447 7.96484 26.2485C5.84946 24.9523 4.14252 23.0858 3.04004 20.8633"
        stroke="url(#paint1_linear_10524_80194)"
        strokeWidth="2"
      />
      <path
        d="M3.04083 20.8612C2.13687 19.0392 1.6665 17.0329 1.6665 14.999C1.6665 12.9651 2.13687 10.9587 3.04083 9.13672"
        stroke="url(#paint2_linear_10524_80194)"
        strokeWidth="2"
      />
      <path
        d="M3.04004 9.13719C4.14252 6.9147 5.84946 5.04819 7.96484 3.752C10.0802 2.45581 12.5183 1.7825 14.999 1.80937"
        stroke="url(#paint3_linear_10524_80194)"
        strokeWidth="2"
      />
      <path
        d="M15 1.80937C17.4808 1.7825 19.9188 2.45581 22.0342 3.752C24.1496 5.04819 25.8565 6.9147 26.959 9.13719"
        stroke="url(#paint4_linear_10524_80194)"
        strokeWidth="2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10524_80194"
          x1="26.959"
          y1="20.8633"
          x2="20.4291"
          y2="31.5189"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#08B898" stopOpacity="0" />
          <stop offset="1" stopColor="#08B898" stopOpacity="0.33" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10524_80194"
          x1="14.999"
          y1="28.1919"
          x2="8.46918"
          y2="17.5363"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#08B898" stopOpacity="0.33" />
          <stop offset="1" stopColor="#08B898" stopOpacity="0.66" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10524_80194"
          x1="1.6665"
          y1="20.8612"
          x2="1.6665"
          y2="9.13672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#08B898" stopOpacity="0.66" />
          <stop offset="1" stopColor="#08B898" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10524_80194"
          x1="3.04004"
          y1="9.13719"
          x2="9.56991"
          y2="-1.51843"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#08B898" />
          <stop offset="1" stopColor="#08B898" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10524_80194"
          x1="15"
          y1="1.80859"
          x2="21.5299"
          y2="12.4642"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#08B898" />
          <stop offset="1" stopColor="#08B898" />
        </linearGradient>
      </defs>
    </svg>
  );
};
